// const argv = require('minimist')(process.argv.slice(2))
const apiEnv = process.env.VUE_APP_API_HOST || 'alpha'
// module.exports = JSON.stringify(apiEnv)
module.exports = apiEnv
